import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import {State as CoreState} from '@emm/core/store/core.reducer';
import { ChangeSetsActions } from './change-sets.actions';
import { ChangeSetsSelectors } from './change-sets.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {ChangeSet} from '@emm/core/models/change-set.model';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';

export interface ChangeSetsQueries extends AsyncActionQueries {
    all$: Observable<ChangeSet[]>;
    selected$: Observable<ChangeSet>;
}

@Injectable({
    providedIn: 'root'
})
export class MenuChangeSetsStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>) {
        super(store, ChangeSetsSelectors);
    }



    dispatch = {
        redirectToDate: (date: string) => this.store.dispatch(ChangeSetsActions.redirectToDate({ date })),
        loadFutureChangeSets: () => this.store.dispatch(ChangeSetsActions.loadFutureChangeSets()),
        openChangeSetsDialog: () => this.store.dispatch(ChangeSetsActions.openViewDialog())
    };



    queries: ChangeSetsQueries = {
        all$: this.selectNonNil(ChangeSetsSelectors.getValidAll),
        selected$: this.selectNonNil(ChangeSetsSelectors.getSelected),
        ...this.asyncActionQueries
    };



}
